"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoGeneratedCommentsEnum = void 0;
var AutoGeneratedCommentsEnum;
(function (AutoGeneratedCommentsEnum) {
    // Expenses
    AutoGeneratedCommentsEnum["SUBSCRIPTION_PAUSED"] = "subscription.paused";
    AutoGeneratedCommentsEnum["SUBSCRIPTION_RESUMED"] = "subscription.resumed";
    AutoGeneratedCommentsEnum["REQUEST_CREATED"] = "request.created";
    AutoGeneratedCommentsEnum["REIMBURSEMENT_REQUEST_CREATED"] = "request.reimbursement_created";
    AutoGeneratedCommentsEnum["INVOICE_REQUEST_CREATED"] = "request.invoice_created";
    AutoGeneratedCommentsEnum["PURCHASE_REQUEST_CREATED"] = "request.purchase_created";
    AutoGeneratedCommentsEnum["MILEAGE_REQUEST_CREATED"] = "request.mileage_created";
    AutoGeneratedCommentsEnum["PER_DIEM_REQUEST_CREATED"] = "request.per_diem_created";
    AutoGeneratedCommentsEnum["HOSPITALITY_REQUEST_CREATED"] = "request.hospitality_created";
    AutoGeneratedCommentsEnum["STANDARD_REIMBURSEMENT_CREATED"] = "request.standard_reimbursement_created";
    AutoGeneratedCommentsEnum["REQUEST_UPDATED"] = "request.updated";
    AutoGeneratedCommentsEnum["REQUEST_UPDATED_VIA_OCR"] = "request.updated_via_ocr";
    AutoGeneratedCommentsEnum["REQUEST_DELETED"] = "request.deleted";
    AutoGeneratedCommentsEnum["PURCHASE_REQUEST_APPROVED"] = "request.purchase_approved";
    AutoGeneratedCommentsEnum["INVOICE_REQUEST_APPROVED"] = "request.invoice_approved";
    AutoGeneratedCommentsEnum["PER_DIEM_APPROVED"] = "request.per_diem_approved";
    AutoGeneratedCommentsEnum["MILEAGE_APPROVED"] = "request.mileage_approved";
    AutoGeneratedCommentsEnum["HOSPITALITY_APPROVED"] = "request.hospitality_approved";
    AutoGeneratedCommentsEnum["STANDARD_REIMBURSEMENT_APPROVED"] = "request.standard_reimbursement_approved";
    AutoGeneratedCommentsEnum["PURCHASE_REQUEST_REJECTED"] = "request.purchase_rejected";
    AutoGeneratedCommentsEnum["INVOICE_REQUEST_REJECTED"] = "request.invoice_rejected";
    AutoGeneratedCommentsEnum["PER_DIEM_REJECTED"] = "request.per_diem_rejected";
    AutoGeneratedCommentsEnum["MILEAGE_REJECTED"] = "request.mileage_rejected";
    AutoGeneratedCommentsEnum["HOSPITALITY_REJECTED"] = "request.hospitality_rejected";
    AutoGeneratedCommentsEnum["STANDARD_REIMBURSEMENT_REJECTED"] = "request.standard_reimbursement_rejected";
    AutoGeneratedCommentsEnum["REQUEST_REJECTED"] = "request.rejected";
    AutoGeneratedCommentsEnum["REQUEST_REVIEW_REJECTED"] = "request.review_rejected";
    AutoGeneratedCommentsEnum["REQUEST_REJECTION_NOTE"] = "request.rejection_note";
    AutoGeneratedCommentsEnum["REQUEST_REVIEWED"] = "request.reviewed";
    AutoGeneratedCommentsEnum["REQUEST_PAID"] = "request.paid";
    AutoGeneratedCommentsEnum["REQUEST_EXPORTED"] = "request.exported";
    AutoGeneratedCommentsEnum["REQUEST_EXPORTED_INFO"] = "request.exported_info";
    AutoGeneratedCommentsEnum["REQUEST_APPROVE_REMINDER_SENT"] = "request.reminder_sent";
    AutoGeneratedCommentsEnum["REQUEST_TAG_ATTACHED"] = "request.tag.attach";
    AutoGeneratedCommentsEnum["REQUEST_TAG_DETACHED"] = "request.tag.detach";
    AutoGeneratedCommentsEnum["REQUEST_INVOICE_UPLOAD_REMINDER_SENT"] = "request.invoice_upload_reminder_sent";
    AutoGeneratedCommentsEnum["INVOICE_UPLOADED"] = "request.invoice_uploaded";
    AutoGeneratedCommentsEnum["INVOICE_DELETED"] = "request.invoice_deleted";
    AutoGeneratedCommentsEnum["DELIVERY_NOTE_UPLOADED"] = "request.delivery_note_uploaded";
    AutoGeneratedCommentsEnum["DELIVERY_NOTE_DELETED"] = "request.delivery_note_deleted";
    AutoGeneratedCommentsEnum["OFFER_UPLOADED"] = "request.offer_uploaded";
    AutoGeneratedCommentsEnum["OFFER_DELETED"] = "request.offer_deleted";
    AutoGeneratedCommentsEnum["MATCH"] = "request.match";
    AutoGeneratedCommentsEnum["UNMATCH"] = "request.unmatch";
    AutoGeneratedCommentsEnum["UNMATCH_AND_RESET"] = "request.unmatch_and_reset";
    AutoGeneratedCommentsEnum["AUTO_MATCH"] = "request.auto_match";
    AutoGeneratedCommentsEnum["AUTO_MATCH_INVOICE"] = "request.auto_match_invoice";
    AutoGeneratedCommentsEnum["AUTO_EXPORT_DATEV_ONLINE"] = "request.auto_exported_datev_online";
    AutoGeneratedCommentsEnum["AUTO_EXPORT_DATEV_ONLINE_SKIPPED"] = "request.auto_exported_datev_online_skipped";
    AutoGeneratedCommentsEnum["SKIPPED_PAYMENT"] = "request.skipped_payment";
    AutoGeneratedCommentsEnum["SKIPPED_PAYMENT_FOR_REFUND"] = "request.skipped_payment_for_refund";
    AutoGeneratedCommentsEnum["AUTO_SKIP_STEPS_DUE_TO_PAYMENT_FLOW_INFO"] = "request.auto_skip_steps_due_to_payment_flow_info";
    AutoGeneratedCommentsEnum["INBOX_INVOICE_ATTACHED"] = "request.inbox_invoice_attached";
    AutoGeneratedCommentsEnum["INBOX_INVOICE_ATTACHED_WITH_FILENAME"] = "request.inbox_invoice_attached_with_filename";
    AutoGeneratedCommentsEnum["INBOX_INVOICE_ATTACHED_WITH_FILENAME_AND_UPLOAD_DATE"] = "request.inbox_invoice_attached_with_filename_and_upload_date";
    AutoGeneratedCommentsEnum["INVOICE_UPLOADED_WITH_FILENAME"] = "request.invoice_uploaded_with_filename";
    AutoGeneratedCommentsEnum["INVOICE_DELETED_WITH_FILENAME"] = "request.invoice_deleted_with_filename";
    // Vendors
    AutoGeneratedCommentsEnum["VENDOR_CREATED"] = "vendor.created";
    AutoGeneratedCommentsEnum["VENDOR_UPDATED"] = "vendor.updated";
    AutoGeneratedCommentsEnum["VENDOR_DELETED"] = "vendor.deleted";
    AutoGeneratedCommentsEnum["VENDOR_APPROVED"] = "vendor.approved";
    AutoGeneratedCommentsEnum["VENDOR_REJECTED"] = "vendor.rejected";
    AutoGeneratedCommentsEnum["VENDOR_REQUESTED"] = "vendor.requested";
    AutoGeneratedCommentsEnum["VENDOR_CONTRACT_UPLOADED"] = "vendor.contract_uploaded";
    AutoGeneratedCommentsEnum["VENDOR_CONTRACT_DELETED"] = "vendor.contract_deleted";
    AutoGeneratedCommentsEnum["EXPENSE_TAG_CREATED"] = "expense_tag.created";
    AutoGeneratedCommentsEnum["EXPENSE_TAG_DELETED"] = "expense_tag.deleted";
    AutoGeneratedCommentsEnum["REQUEST_MARKED_AS_DONE"] = "request.marked_as_done";
})(AutoGeneratedCommentsEnum = exports.AutoGeneratedCommentsEnum || (exports.AutoGeneratedCommentsEnum = {}));
